import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatPHP } from "@/lib/gems";

// The Gem Collector's storefront: it buys gems, it sells nothing. The fee is
// read from the server so this page can never promise a figure the exchange
// does not charge; if the read fails the figure is left out, not guessed.
export default function GemSellCallout({ store }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let live = true;
    api.get("/exchange/config").then((r) => { if (live) setConfig(r.data); }).catch(() => {});
    return () => { live = false; };
  }, []);

  const feeKnown = config && config.fee_php !== null && config.fee_php !== undefined
    && Number.isFinite(Number(config.fee_php));
  const fee = feeKnown ? `, less a ${formatPHP(config.fee_php)} fee` : "";
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 md:py-14" data-testid="gem-sell-callout">
      <h2 className="font-display text-2xl md:text-4xl font-black tracking-tight text-primary text-center">
        Sell your gems to {store?.name || "The Gem Collector"}
      </h2>
      <ol className="mt-6 space-y-3 max-w-md mx-auto text-muted-foreground list-decimal pl-5" data-testid="gem-sell-steps">
        <li>Link your ePlayQuest account.</li>
        <li>Choose how many gems to sell.</li>
        <li>Get pesos in GCash or Maya{fee}.</li>
      </ol>
      {config && !config.enabled && (
        <p className="mt-4 text-sm text-center" data-testid="gem-sell-closed">Selling opens soon.</p>
      )}
      <div className="mt-8 flex justify-center">
        <Link to="/app/gems" className="v-btn-primary w-full sm:w-auto justify-center" data-testid="gem-sell-cta">Sell your gems</Link>
      </div>
    </section>
  );
}
